
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Icon } from 'vant';
import VoteButton from './VoteButton.vue';

Vue.use(Icon);
@Component({
  components: {
    VoteButton,
  },
})
export default class Item extends Vue {
  @Prop() item!: any;
  @Prop() index!: any;

  votSuccess(data: any) {
    this.$emit('votSuccess', data);
  }
}
